import { render, staticRenderFns } from "./updateBeneficiary.vue?vue&type=template&id=0880623f"
import script from "./updateBeneficiary.vue?vue&type=script&lang=js"
export * from "./updateBeneficiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports